import { BaseEntity } from 'yt-ng-framework';

export class PregledGo extends BaseEntity {
  constructor() {
      super();
  }
  
  Osoba: string = null;
  StariPravoDana: number = null;
  StariIskoristenoDana: number = null;
  StariPropaloDana: number = null;
  StariOstaloDana: number = null;
  NoviPravoDana: number = null;
  NoviIskoristenoDana: number = null;
  NoviOstaloDana: number = null;
  OstaloDana: number = null;

  Deserialize(input: any) {
      this.ID = input.ID;
      this.Osoba = input.Osoba;
      this.StariPravoDana = input.StariPravoDana;
      this.StariIskoristenoDana = input.StariIskoristenoDana;
      this.StariPropaloDana = input.StariPropaloDana;
      this.StariOstaloDana = input.StariOstaloDana;
      this.NoviPravoDana = input.NoviPravoDana;
      this.NoviIskoristenoDana = input.NoviIskoristenoDana;
      this.NoviOstaloDana = input.NoviOstaloDana;
      this.OstaloDana = input.OstaloDana;
 
      return this;
  }

  Serialize(input: PregledGo) {
      return input;      
  }
}
